/**
 * DecayRiskIcon — Mi6 custom glyph: clock-rewind with warning triangle
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function DecayRiskIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Clock face */}
      <circle cx="36" cy="36" r="20" stroke="currentColor" strokeWidth="1.5" />
      {/* Clock hands — rewind position (pointing back/left) */}
      <line x1="36" y1="36" x2="36" y2="23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="36" y1="36" x2="26" y2="41" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Rewind arrow arc around clock */}
      <path d="M20 28 C16 34 18 44 26 50" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <polyline points="19,22 20,28 26,27" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Warning triangle — bottom right */}
      <path d="M52 54 L62 70 L42 70 Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Warning exclamation (vertical bar + dot) */}
      <line x1="52" y1="60" x2="52" y2="65" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="52" cy="68" r="1" fill="currentColor" />
    </svg>
  );
}
